import {State} from '../types'

export const getModalType = (state: State) => {
  return state.modals.modalType || ''
}
